import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Stack,
  Tooltip,
  Box,
  CircularProgress,
  Avatar,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CircularLoader,
  Iconify,
  Scrollbar,
  TaskCreatedAt,
} from "src/components";
import { TASK_STATUS_OPTIONS } from "src/constants";
import { isColorLight, truncateText } from "src/utils";
import moment from "moment";
import OpenTaskDetail from "./OpenTaskDetail";
import RecurringEventDialog from "./RecurringEventDialog";
import EventDetailDialog from "./EventDetailDialog";
import RecurringEventCard from "./RecurringEventCard";
import DashboardTaskCard from "src/pages/dashboard/components/DaashboardTaskCard";

/* <<--------------------------------------------------------->> */
const CalendarComponent = ({
  loading = false,
  events,
  getCalendarTasks,
  recurringEvents,
}) => {
 
  const is_mobile_view = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [tasksForDay, setTasksForDay] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [openTaskDetailDialog, setOpenTaskDetailDialog] = useState(false);
  const [modalRecurringEvent, setModalRecurringEvent] = useState(false);

  const [openEventDialog, setOpenEventDialog] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [eventsForDay, setEventsForDay] = useState([]);

  const [preFillData, setPreFillData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const handleCloseEventDalog = () => {
    setOpenEventDialog(false);
    setSelectedEvent(null);
  };
  const openEditEventDialog = (eventData) => {
    setPreFillData(eventData);
    setModalRecurringEvent(true);
    setIsEditing(true);
  };

  const handleDateClick = (info) => {
    console.log(info, "info_");
    // console.log(recurringEvents, "all_filterd_events_by_date");
    console.log(info.dateStr, "clicked_date");
    const clickedDate = info.dateStr;
    setSelectedDate(clickedDate);

    // ----------------task Filter--------------------
    const filteredTasks = events.filter((task) => {
      const taskStartDate = moment(task.start).format("YYYY-MM-DD");
      return taskStartDate === clickedDate;
    });
    setTasksForDay(filteredTasks);
    // ----------------Event Filter--------------------
    const recurringFilteredEvents = recurringEvents.filter((item) => {
      const startDate = moment(item.start).format("YYYY-MM-DD");
      return startDate === clickedDate;
    });
    setEventsForDay(recurringFilteredEvents); // for RecuringEventcard

    if (filteredTasks.length > 0 || recurringFilteredEvents.length > 0) {
      setOpenModal(true);
    } else {
      setModalRecurringEvent(true);
    }
  };

  const onEventClick = (info) => {
    const data = info.event.extendedProps;
    const clickedDate = info?.event._instance.range.start;
    setSelectedDate(clickedDate);

    if (data.more.task_title) {
      setSelectedTask(data.more);
      setOpenTaskDetailDialog(true);
    } else {
      console.log(info, "info_ eventclick");
      setOpenEventDialog(true); //opens event detail dialog
      // setSelectedEvent(data.more);
      const title = info.event._def.title; // updated event title
      const updatedEvent = {
        ...data.more,
        event_title: title,
      };
      setSelectedEvent(updatedEvent);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedDate(null);
  };

  // const navigateEvent = (data) => {
  //   console.log(data, "data");
  //   navigate(`/workspaces/projects/${data.project.id}`, {
  //     state: { task_id: data._id },
  //   });
  // };
  /* <<--------------------------------------------------------->> */
  /* <<--------------------------------------------------------->> */
  const getStatusProps = (value) => {
    if (!value) {
      return { color: "" };
    }
    if (String(value) === "0") {
      return { color: "#FFC107" };
    }
    let [found] = TASK_STATUS_OPTIONS.filter(
      (item) => String(item.value) === String(value)
    );
    if (found) {
      return found;
    }
  };
  const renderEventContent = (info) => {
    const { more, bg } = info.event._def.extendedProps;

    if (!more) {
      return <></>;
    }

    return (
      <div style={{ overflow: "hidden", width: "100%" }}>
        <div
          style={{
            fontSize: is_mobile_view && "10px",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            color: "#000",
            backgroundColor: more?.task_title ? `${bg}30` : "#efefef",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            padding: is_mobile_view ? "0px 4px" : "2px 6px",
            cursor: "pointer",
            fontWeight: "500",
            borderRadius: "4px",
            transition: "background-color 0.2s ease-in-out",
          }}
          onMouseEnter={(e) => {
            if (more?.task_title) {
              e.currentTarget.style.backgroundColor = `${bg}50`;
            } else {
              e.currentTarget.style.backgroundColor = "#e2e2e2";
            }
          }}
          onMouseLeave={(e) => {
            if (more?.task_title) {
              e.currentTarget.style.backgroundColor = `${bg}30`; // task - light status color
            } else {
              e.currentTarget.style.backgroundColor = "#efefef";
            }
          }}
        >
          <Iconify
            icon={
              more?.task_title
                ? "bi:square-fill"
                : "pepicons-pencil:circle-filled"
            }
            width={is_mobile_view ? 10 : 14}
            height={is_mobile_view ? 10 : 14}
            color={bg}
            style={{ flexShrink: 0 }}
          />
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {/* {more?.task_title || more?.title} */}
            {more?.task_title || info.event._def.title}
          </span>
        </div>
      </div>
    );
  };

  /* <<--------------------------------------------------------->> */
  /* <<--------------------------------------------------------->> */
  // if (loading) {
  //   return (
  //     <div className="">
  //       <CircularLoader />
  //     </div>
  //   );
  // }

  return (
    <>
      <div className="full-calendar relative">
        <FullCalendar
          dateClick={handleDateClick} // opens clicked date modal
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          headerToolbar={{
            left: "today prev,next",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay",
          }}
          eventContent={renderEventContent}
          eventClick={onEventClick}
          events={[...events, ...recurringEvents]}
          initialView="dayGridMonth"
          // editable={true}
          // selectable={true}
          selectMirror={true}
          dayMaxEvents={true}
          weekends={true}
        />
        {/* --------------------------------------- */}
        {loading && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundColor: "#ffffff75",
              display: "flex",
              paddingTop: 260,
              justifyContent: "center",
              zIndex: 1,
            }}
          >
            {/* <CircularLoader /> */}
            <CircularProgress />
          </div>
        )}

        {/* open task directly - dont show card ---------------- */}
        {selectedTask && (
          <div>
            <OpenTaskDetail
              getCalendarTasks={getCalendarTasks}
              task={selectedTask}
              open={openTaskDetailDialog}
              setOpen={setOpenTaskDetailDialog}
            />
          </div>
        )}
        {/* Event/Task detail Modal ---------------------------- */}
        <Dialog fullWidth open={openModal} onClose={handleCloseModal}>
          <DialogTitle
            className="d-flex align-items-center justify-content-between"
            sx={{
              p: is_mobile_view ? "16px 13px" : "16px 24px",
              fontSize: is_mobile_view ? "12px" : "16px",
            }}
          >
            <div className="d-flex align-items-center">
              <Iconify
                icon="simple-line-icons:calender"
                style={{ marginRight: "8px" }}
              />
              {moment(selectedDate).format("dddd, D MMMM YYYY")}
            </div>
            <Button
              onClick={() => {
                setModalRecurringEvent(true);
              }}
              variant="outlined"
              size="small"
            >
              Create Event
            </Button>
          </DialogTitle>
          <DialogContent
            sx={{
              minHeight: "300px",
              p: is_mobile_view ? "20px 6px" : "20px 24px",
            }}
            className="pb-0"
          >
            {/* ------------------------------------------------------- */}
            {tasksForDay?.length > 0 &&
              tasksForDay?.map((task, index) => (
                <Scrollbar
                  sx={{
                    maxHeight: "60vh",
                  }}
                  key={index}
                >
                  <Stack spacing={1} sx={{ p: 0.5 }}>
                    <DashboardTaskCard
                      getCalendarTasks={getCalendarTasks}
                      task={task.more}
                      showIcon={true}
                    />
                  </Stack>
                </Scrollbar>
              ))}
            {eventsForDay?.length > 0 &&
              eventsForDay?.map((event, index) => (
                <div style={{ padding: "4px" }} key={index}>
                  <RecurringEventCard setOpenEventDialog={setOpenEventDialog} setSelectedEvent={setSelectedEvent} event={event} />
                </div>
              ))}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Recurring Event Dialog -----------------------------------  */}
        <RecurringEventDialog
          open={modalRecurringEvent}
          setOpen={setModalRecurringEvent}
          selectedDate={selectedDate}
          getCalendarTasks={getCalendarTasks}
          closeListDialog={handleCloseModal}
          preFillData={preFillData}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          handleCloseEventDalog={handleCloseEventDalog}
        />
        {/* Event Detail Dialog -----------------------------------  */}
        <EventDetailDialog
          openModal={openEventDialog}
          onClose={handleCloseEventDalog}
          event={selectedEvent}
          selectedDate={selectedDate}
          getCalendarTasks={getCalendarTasks}
          onEdit={openEditEventDialog}
        />
      </div>
    </>
  );
};

export default CalendarComponent;
